import { api } from "./client";

const employeesCanonical = {
  list: () => api.get("/employees-canonical"),
  create: (data) => api.post("/employees-canonical", data),
  update: (id, data) => api.patch(`/employees-canonical/${id}`, data),
  merge: (primary_id, secondary_id) =>
    api.post("/employees-canonical/merge", { primary_id, secondary_id }),
  split: (id, aliases_to_split, new_canonical_name) =>
    api.post("/employees-canonical/split", {
      id,
      aliases_to_split,
      new_canonical_name,
    }),
  rebuild: () => api.post("/employees-canonical/rebuild", {}),
  bulkDelete: (ids) => api.post("/employees-canonical/bulk-delete", { ids }),
  reactivate: (id) => api.post(`/employees-canonical/${id}/reactivate`, {}),
  // Phase 4 Fix C — hard delete + blacklist
  hardDeleteOne: (id) => api.delete(`/employees-canonical/${id}/purge`),
  purgeInactive: () => api.delete("/employees-canonical/inactive/purge"),
  listBlacklist: () => api.get("/employees-canonical/blacklist"),
  unblockBlacklist: (nameNorm) =>
    api.delete(`/employees-canonical/blacklist/${encodeURIComponent(nameNorm)}`),
  // Phase 10.6 — export/import for cross-environment migration.
  // The export endpoint streams `application/json` with a
  // `Content-Disposition: attachment` header; the caller decides whether to
  // turn it into a real file download (see `<ImportExportDialog>`).
  export: () => api.get("/admin/canonicals/export"),
  import: (payload, { mode = "merge", confirm = false } = {}) => {
    const params = new URLSearchParams({ mode });
    if (confirm) params.set("confirm", "true");
    return api.post(
      `/admin/canonicals/import?${params.toString()}`,
      payload,
    );
  },
  // Phase 10.7 — bulk deactivate for the TE350 activity review flow.
  bulkDeactivate: (payload) =>
    api.post("/admin/canonicals/bulk-deactivate", payload),
};

export default employeesCanonical;
